export const Yape = {
	name: 'Yape',
	code: 'yape',
};

export default { Yape };



// WEBPACK FOOTER //
// ./src/shared/enums/depositPayment.js